import * as Types from '../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ExpensesSearchQueryVariables = Types.Exact<{
  searchText?: Types.InputMaybe<Types.Scalars['String']>;
  workLocation?: Types.InputMaybe<Types.Scalars['String']>;
  status?: Types.InputMaybe<Types.TimesheetStatus>;
  week?: Types.InputMaybe<Types.Scalars['LocalDate']>;
  reimbursement?: Types.InputMaybe<Types.TimesheetSearchReimbursementOption>;
  payrollAdmin?: Types.InputMaybe<Types.Scalars['String']>;
  payPeriod?: Types.InputMaybe<Types.PayPeriod>;
  token?: Types.InputMaybe<Types.Scalars['String']>;
  dateBefore?: Types.InputMaybe<Types.Scalars['String']>;
  dateAfter?: Types.InputMaybe<Types.Scalars['String']>;
  userPrincipalName?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type ExpensesSearchQuery = { __typename?: 'QueryModel', timesheets?: { __typename?: 'TimesheetsQueryModel', expenseSearch?: { __typename?: 'ConnectionOfExpenseSearchResult', token?: string | null, records?: Array<{ __typename?: 'ExpenseSearchResult', employee?: { __typename?: 'Employee', userPrincipalName: string, firstName: string, middleInitial: string, lastName: string } | null, expense?: { __typename: 'AdHocExpense', rate: number, quantity: number, eeCode: string, notes?: string | null, billableAmount?: number | null, payable: Types.Payable, expenseAccount?: string | null, glAccount?: string | null, payableAmount: number, date: string, rateName: string, rateSheetName: string, id: string, invoiceLabel?: string | null, lastAdminNotes?: string | null, project?: { __typename?: 'Project', name: string, number: number } | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null } | { __typename: 'AtvExpense', eeCode: string, notes?: string | null, billableAmount?: number | null, payable: Types.Payable, expenseAccount?: string | null, glAccount?: string | null, payableAmount: number, date: string, rateName: string, rateSheetName: string, id: string, invoiceLabel?: string | null, lastAdminNotes?: string | null, project?: { __typename?: 'Project', name: string, number: number } | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null } | { __typename: 'FuelExpense', quantity: number, receiptTotal: number, payerInformation: Types.PayerInformation, companyVehicle: boolean, eeCode: string, notes?: string | null, billableAmount?: number | null, payable: Types.Payable, expenseAccount?: string | null, glAccount?: string | null, payableAmount: number, date: string, rateName: string, rateSheetName: string, id: string, invoiceLabel?: string | null, lastAdminNotes?: string | null, fuelOdometer?: number | null, fuelVehicleNumber?: string | null, fuelReceiptId?: string | null, fuelReceiptUrl?: string | null, project?: { __typename?: 'Project', name: string, number: number } | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null } | { __typename: 'MileageExpense', beginningOdometer: number, endingOdometer: number, companyVehicle: boolean, eeCode: string, notes?: string | null, billableAmount?: number | null, payable: Types.Payable, expenseAccount?: string | null, glAccount?: string | null, payableAmount: number, date: string, rateName: string, rateSheetName: string, id: string, invoiceLabel?: string | null, lastAdminNotes?: string | null, mileageVehicleNumber?: string | null, project?: { __typename?: 'Project', name: string, number: number } | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null } | { __typename: 'MobileAllowanceExpense', eeCode: string, notes?: string | null, billableAmount?: number | null, payable: Types.Payable, expenseAccount?: string | null, glAccount?: string | null, payableAmount: number, date: string, rateName: string, rateSheetName: string, id: string, invoiceLabel?: string | null, lastAdminNotes?: string | null, project?: { __typename?: 'Project', name: string, number: number } | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null } | { __typename: 'PerDiemExpense', eeCode: string, notes?: string | null, billableAmount?: number | null, payable: Types.Payable, expenseAccount?: string | null, glAccount?: string | null, payableAmount: number, date: string, rateName: string, rateSheetName: string, id: string, invoiceLabel?: string | null, lastAdminNotes?: string | null, perDiemReceiptId?: string | null, perDiemReceiptUrl?: string | null, project?: { __typename?: 'Project', name: string, number: number } | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null } | { __typename: 'ReceiptValuedExpense', payerInformation: Types.PayerInformation, odometer?: number | null, vehicleNumber?: string | null, receiptTotal: number, receiptImageId?: string | null, receiptImageUrl?: string | null, eeCode: string, notes?: string | null, billableAmount?: number | null, payable: Types.Payable, expenseAccount?: string | null, glAccount?: string | null, payableAmount: number, date: string, rateName: string, rateSheetName: string, id: string, invoiceLabel?: string | null, lastAdminNotes?: string | null, project?: { __typename?: 'Project', name: string, number: number } | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null } | { __typename: 'TcpAllowanceExpense', eeCode: string, notes?: string | null, billableAmount?: number | null, payable: Types.Payable, expenseAccount?: string | null, glAccount?: string | null, payableAmount: number, date: string, rateName: string, rateSheetName: string, id: string, invoiceLabel?: string | null, lastAdminNotes?: string | null, project?: { __typename?: 'Project', name: string, number: number } | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null } | null } | null> | null } | null } | null };


export const ExpensesSearchDocument = gql`
    query ExpensesSearch($searchText: String, $workLocation: String, $status: TimesheetStatus, $week: LocalDate, $reimbursement: TimesheetSearchReimbursementOption, $payrollAdmin: String, $payPeriod: PayPeriod, $token: String, $dateBefore: String, $dateAfter: String, $userPrincipalName: String) {
  timesheets {
    expenseSearch(
      searchText: $searchText
      workLocation: $workLocation
      status: $status
      week: $week
      reimbursement: $reimbursement
      payrollAdmin: $payrollAdmin
      payPeriod: $payPeriod
      token: $token
      dateBefore: $dateBefore
      dateAfter: $dateAfter
      userPrincipalName: $userPrincipalName
    ) {
      token
      records {
        employee {
          userPrincipalName
          firstName
          middleInitial
          lastName
        }
        expense {
          __typename
          eeCode
          notes
          billableAmount
          payable
          expenseAccount
          glAccount
          payableAmount
          date
          rateName
          rateSheetName
          id
          invoiceLabel
          location {
            state
            county
          }
          lastAdminNotes
          ... on AtvExpense {
            project {
              name
              number
            }
          }
          ... on AdHocExpense {
            rate
            quantity
            project {
              name
              number
            }
          }
          ... on FuelExpense {
            fuelOdometer: odometer
            fuelVehicleNumber: vehicleNumber
            quantity
            receiptTotal
            payerInformation
            companyVehicle
            fuelReceiptId: receiptImageId
            fuelReceiptUrl: receiptImageUrl
            project {
              name
              number
            }
          }
          ... on MileageExpense {
            beginningOdometer
            endingOdometer
            mileageVehicleNumber: vehicleNumber
            companyVehicle
            project {
              name
              number
            }
          }
          ... on MobileAllowanceExpense {
            project {
              name
              number
            }
          }
          ... on PerDiemExpense {
            project {
              name
              number
            }
            perDiemReceiptId: receiptImageId
            perDiemReceiptUrl: receiptImageUrl
          }
          ... on ReceiptValuedExpense {
            payerInformation
            odometer
            vehicleNumber
            receiptTotal
            receiptImageId
            receiptImageUrl
            project {
              name
              number
            }
          }
          ... on TcpAllowanceExpense {
            project {
              name
              number
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useExpensesSearchQuery__
 *
 * To run a query within a React component, call `useExpensesSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpensesSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpensesSearchQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      workLocation: // value for 'workLocation'
 *      status: // value for 'status'
 *      week: // value for 'week'
 *      reimbursement: // value for 'reimbursement'
 *      payrollAdmin: // value for 'payrollAdmin'
 *      payPeriod: // value for 'payPeriod'
 *      token: // value for 'token'
 *      dateBefore: // value for 'dateBefore'
 *      dateAfter: // value for 'dateAfter'
 *      userPrincipalName: // value for 'userPrincipalName'
 *   },
 * });
 */
export function useExpensesSearchQuery(baseOptions?: Apollo.QueryHookOptions<ExpensesSearchQuery, ExpensesSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpensesSearchQuery, ExpensesSearchQueryVariables>(ExpensesSearchDocument, options);
      }
export function useExpensesSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpensesSearchQuery, ExpensesSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpensesSearchQuery, ExpensesSearchQueryVariables>(ExpensesSearchDocument, options);
        }
export type ExpensesSearchQueryHookResult = ReturnType<typeof useExpensesSearchQuery>;
export type ExpensesSearchLazyQueryHookResult = ReturnType<typeof useExpensesSearchLazyQuery>;
export type ExpensesSearchQueryResult = Apollo.QueryResult<ExpensesSearchQuery, ExpensesSearchQueryVariables>;